module.exports = __webpack_public_path__ + "static/media/chiller_single.2491a9c5.png";